import { Component, Inject } from "@angular/core";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { WorkSchedulesDataService } from "../core/workschedules.dataservice";
import { EditBase } from "../settings/shared/edit.base";

@Component({
    selector: "crew-edit-work-schedule",
    template: require('./work-schedule.edit.component.html')
})
export class EditWorkScheduleComponent extends EditBase<Nema.Crew.Model.WorkSchedule> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('workSchedule') entity: Nema.Crew.Model.WorkSchedule,
        @Inject(WorkSchedulesDataService.Id) workScheduleDataService: WorkSchedulesDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, workScheduleDataService, $log, isNew);

        if (!isNew) {
            (<any>this.entity.Steps).load();
        }
    }
    
    public entityDisplayName = "Work Schedule";

    public listStateName = "app.activities.workschedules";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/work-schedule.edit.component.ts